import { useContext } from "react";

import { Button } from "primereact/button";

import { SegmentedProgressBar } from "sj-ui-toolkit/src/atlas/components";
import { themeClasses } from "sj-ui-toolkit/src/atlas/utils";

import { useLearnContext } from "../../../../../context/LearnContext";
import { VideoContext } from "../../VideoContext";

import QuizReviewQuestions from "./QuizReviewQuestions";

import S from "./_styles.module.scss";

export default function QuizReview() {
  const { isTournament } = useLearnContext();
  const { quiz, isLessonComplete, onLessonFinish, onQuizRetake, onExerciseLaunch } =
    useContext(VideoContext);

  const passed = quiz.assessment.result === "passed";
  const score = quiz.assessment.assessmentScore;

  const segments = [
    {
      key: "userScore",
      value: score,
      label: `Your score: ${score}%`,
    },
    {
      key: "remainder",
      value: Math.max(0, 100 - score),
      label: "Remaining",
    },
  ];

  const segmentColors = {
    userScore: passed ? themeClasses.bgTealDataviz1 : themeClasses.bgIndigoDataviz1,
    remainder: themeClasses.bgSurface200,
  };

  return (
    <>
      <div className={S.quizBody}>
        <div className="flex flex-col gap-2.5">
          <h2 className="atlas-h1">
            {passed ? "Nicely done." : "So close."} <span className="text-muted-aaa">{score}%</span>
          </h2>
          <SegmentedProgressBar
            segments={segments}
            segmentColors={segmentColors}
            markerPercentage={80}
            valueNow={score}
            height="h-5"
            ariaLabel="Quiz score"
          />
          <div className={`relative ${S.captionRow}`}>
            <span className="body-sm text-muted-aaa">
              {passed
                ? "You successfully completed the quiz."
                : "Select the Retry quiz button to try again."}
            </span>
            <span className={`body-sm text-muted-aaa whitespace-nowrap ${S.passLabel}`}>
              80% needed to pass
            </span>
          </div>
        </div>
        <QuizReviewQuestions />
      </div>
      <div className={S.quizFooter}>
        {!passed && (
          <div className="flex justify-end">
            <Button label="Retry quiz" icon="pi pi-replay" onClick={onQuizRetake} />
          </div>
        )}

        {passed && (
          <div className="flex gap-4 justify-end">
            {!isTournament && (
              <Button
                label="Take this quiz again"
                icon="pi pi-replay"
                severity="secondary"
                onClick={onQuizRetake}
              />
            )}
            {isLessonComplete ? (
              <Button label="Finish this lesson" icon="pi pi-check" onClick={onLessonFinish} />
            ) : (
              <Button
                className="self-start"
                label="Complete the exercise"
                onClick={onExerciseLaunch}
              />
            )}
          </div>
        )}
      </div>
    </>
  );
}
